const isDev = process.env.NODE_ENV === 'development';
const prodURL = process.env.VUE_APP_URL;
// const devURL = 'https://sqapi.muyin365.com';
// const devURL = 'http://192.168.0.200:1012';
// const devURL = 'http://192.168.0.210:1012';
const devURL = 'https://openapi.mykj139.cn';
const config = isDev ? devURL : prodURL;
// const config = {
//     // baseUrl: 'http://192.168.0.66:8080/api',
    // baseUrl: 'https://api.muyin365.com/api', //正式
//     // baseUrl: 'http://shuquan.muyin365.com/api', //测试
// }
export default config;
